import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {Approver, ApproverGroup} from '../types'

export const QueryKey = 'approvers-by-function-id'

type UseApproversByFunctionIdParams = {
  plantId: string
  functionId: string | undefined
  options?: Omit<UseQueryOptions<ApproverGroup[], AxiosError, Approver[]>, 'queryKey'>
}

export const useApproversByFunctionId = ({
  plantId,
  functionId,
  options
}: UseApproversByFunctionIdParams) => {
  return useQuery<ApproverGroup[], AxiosError, Approver[]>({
    queryKey: [QueryKey, functionId, plantId],
    queryFn: async ({signal}) => {
      const path = `/shifthandover/${plantId}/system-change-requests/change-function-approver-groups/${functionId}`
      const response = await ApiClient.axiosInstance.get<ApproverGroup[]>(path, {signal})
      return response.data
    },
    select: (data) =>
      data.flatMap(({approvers}) =>
        approvers.map(
          (approver): Approver => ({
            user: approver,
            status: 'pending'
          })
        )
      ),
    ...options
  })
}
